export default __webpack_public_path__ + "static/media/collectionGold.b0bd7c2d.svg";